var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":require("../assets/404@2x.png"),"width":"728px","height":"316px","alt":""}}),_vm._v(" "),_c('p',[_vm._v("\n      网页丢失了…\n    ")]),_vm._v(" "),_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.$router.push({ path: '/' })}}},[_vm._v("返回首页")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b32086d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/404.vue
// module id = null
// module chunks = 